import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Transition as _Transition, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "nav"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "nav-links"
};
const _hoisted_4 = {
  class: "nav-r"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "user-menu-header"
};
const _hoisted_7 = {
  class: "user-menu-avatar"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "user-menu-info"
};
const _hoisted_10 = {
  class: "user-menu-name"
};
const _hoisted_11 = {
  class: "user-menu-phone"
};
const _hoisted_12 = {
  class: "user-menu-body"
};
const _hoisted_13 = {
  key: 0,
  class: "page-footer"
};
const _hoisted_14 = {
  class: "page-footer-copyright"
};
import { ref, provide, computed } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";
import toast from "@/utils/toast";
import { toAigc, toCreateAigc } from "@/utils/index";
import request from "@/utils/request";
import { clearUserData, isLogin, getUserData } from "@/utils/auth";
import LoginDialog from "./LoginDialog.vue";
import useProfileStore from "@/stores/profile-store.js";
import logoImg from "@/assets/images/logo-new.svg";
// import logoTextImg from "@/assets/images/logo-text.png";

export default {
  __name: 'CompetitionLayout',
  props: {
    containerStyle: {
      type: Object,
      default: () => ({})
    },
    showFooter: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const $router = useRouter();
    const profile = useProfileStore();

    // const isDetailPage = $route.name === "competition-detail";
    const year = dayjs().year();
    const isUserLogin = ref(isLogin());
    const showLogin = ref(false);
    const showLogout = ref(false);
    const showUserMenu = ref(false);
    const avatarRef = ref(null);

    // 用户数据
    const userData = computed(() => {
      return getUserData();
    });

    // 浮层位置样式
    const menuStyle = computed(() => {
      if (!avatarRef.value) return {};
      const rect = avatarRef.value.getBoundingClientRect();
      return {
        top: `${rect.bottom + 8}px`,
        right: `${window.innerWidth - rect.right}px`
      };
    });

    // 鼠标移入显示菜单
    let hideTimeout = null;
    const handleMouseEnter = () => {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
      showUserMenu.value = true;
    };

    // 鼠标移出隐藏菜单（带延迟）
    const handleMouseLeave = () => {
      hideTimeout = setTimeout(() => {
        showUserMenu.value = false;
      }, 200);
    };

    // 点击外部关闭菜单
    // const handleClickOutside = (event) => {
    //   if (avatarRef.value && !avatarRef.value.contains(event.target)) {
    //     showUserMenu.value = false;
    //   }
    // };

    // onMounted(() => {
    //   document.addEventListener("click", handleClickOutside);
    // });

    // onUnmounted(() => {
    //   document.removeEventListener("click", handleClickOutside);
    // });

    // 提供给子组件显示登录弹窗的方法
    const triggerLogin = () => {
      showLogin.value = true;
    };
    provide("triggerLogin", triggerLogin);
    const toManage = () => {
      $router.push({
        name: "manage-competition-list"
      });
    };
    const logout = async () => {
      try {
        const res = await request.post("/api/v1/user/logout");
        if (res.code === 200) {
          clearUserData();
          toast("退出成功");
          isUserLogin.value = false;
          window.location.reload();
        } else {
          toast(res.message || "退出失败");
        }
      } catch (error) {
        console.error("退出失败:", error);
        toast("退出失败，请稍后重试");
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_CompetitionDialog = _resolveComponent("CompetitionDialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "nav-brand",
        onClick: _cache[0] || (_cache[0] = $event => _unref(toAigc)(false))
      }, [_createElementVNode("img", {
        src: _unref(logoImg)
      }, null, 8, _hoisted_2)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "nl on",
        onClick: _cache[1] || (_cache[1] = $event => _unref($router).push('/'))
      }, "赛事中心"), _createElementVNode("div", {
        class: "nl",
        onClick: _cache[2] || (_cache[2] = (...args) => _unref(toCreateAigc) && _unref(toCreateAigc)(...args))
      }, "创作台")]), _createElementVNode("div", _hoisted_4, [!isUserLogin.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => showLogin.value = true)
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("立即登录", -1)]))]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "user-menu-wrapper",
        onMouseenter: handleMouseEnter,
        onMouseleave: handleMouseLeave
      }, [_createElementVNode("div", {
        class: "nav-avatar",
        ref_key: "avatarRef",
        ref: avatarRef
      }, [userData.value?.avatar ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: userData.value?.avatar,
        style: {
          "width": "100%",
          "height": "100%",
          "object-fit": "cover"
        }
      }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode("🌊")], 64))], 512), _createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [showUserMenu.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "user-menu",
          style: _normalizeStyle(menuStyle.value)
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [userData.value?.avatar ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: userData.value?.avatar,
          style: {
            "width": "100%",
            "height": "100%",
            "object-fit": "cover"
          }
        }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode("🌊")], 64))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(userData.value?.realname || "芒果灵创用户"), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(userData.value?.phoneMask || "-"), 1)])]), _cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "user-menu-divider"
        }, null, -1)), _createElementVNode("div", _hoisted_12, [_unref(profile)?.isAdmin ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "user-menu-item",
          onClick: toManage
        }, [...(_cache[9] || (_cache[9] = [_createElementVNode("span", {
          class: "icon"
        }, "🔧", -1), _createElementVNode("span", null, "管理后台", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "user-menu-item",
          onClick: _cache[4] || (_cache[4] = $event => showLogout.value = true)
        }, [...(_cache[10] || (_cache[10] = [_createElementVNode("span", {
          class: "icon"
        }, "🚪", -1), _createElementVNode("span", null, "退出登录", -1)]))])])], 4)) : _createCommentVNode("", true)]),
        _: 1
      })], 32))])]), _createVNode(LoginDialog, {
        modelValue: showLogin.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showLogin.value = $event),
        onLoginSuccess: _cache[6] || (_cache[6] = $event => isUserLogin.value = true)
      }, null, 8, ["modelValue"]), _createVNode(_component_CompetitionDialog, {
        modelValue: showLogout.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showLogout.value = $event),
        title: "退出",
        onSubmit: logout
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createElementVNode("div", {
          class: "mbody"
        }, "确定要退出吗？", -1)]))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", {
        class: "page-container",
        style: _normalizeStyle(__props.containerStyle)
      }, [_renderSlot(_ctx.$slots, "default"), props.showFooter ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "page-footer-links"
      }, [_createElementVNode("a", {
        href: ""
      }, "隐私政策"), _createElementVNode("span", null, "·"), _createElementVNode("a", {
        href: ""
      }, "服务条款"), _createElementVNode("span", null, "·"), _createElementVNode("a", {
        href: ""
      }, "社区准则")], -1)), _createElementVNode("div", _hoisted_14, "版权所有 ©" + _toDisplayString(_unref(year)) + " 芒果灵创 & 芒果TV 保留所有权利", 1)])) : _createCommentVNode("", true)], 4)], 64);
    };
  }
};